require('style!../css/front.css')
require('style!../css/bootstrap.css')
require('style!../css/responsive.css')
require('style!../css/style.css')




require('./vendors/jquery-migrate.min.js');
require('./scripts-general.js')

require('./homepage.js');
require('./navBar.js');
require('./vendors/bootstrap.min.js')
require('./jquery.knob.js')
require('./smoothscroll.js')
require('./scrollReveal.js')
require('./zerif.js')
require('./wp-embed.min.js')



//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 0
// module chunks = 0